import io.ktor.client.*

expect annotation class myName(val name:String)
expect fun printPlat(s:Any?)
expect fun getHttpClient(local:Boolean = false):HttpClient